export default __webpack_public_path__ + "static/media/4197.65913bef.png";